export const REGEX = {
  NAME: /^[A-Za-z\s]+$/,
  PHONE_NUMBER: /^\d+$/,
  USER_AGENT: /iPhone|iPad|iPod|Android/i,
  AMERICAN_EXP_CARD_REGEX: /^3[47]/,
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
}
